// Types
import Strategy from 'app/types/Strategy';
import MixpanelEvents from 'app/features/mixpanel/MixpanelEvents';
// Services
import Mixpanel from "app/services/Mixpanel.service";

export const handleBillingInvoicesViewStrategy:Strategy = () => {
  Mixpanel.track(MixpanelEvents.BillingInvoicesView);
};
export const handleSubscriptionsViewStrategy:Strategy = () => {
  Mixpanel.track(MixpanelEvents.SubscriptionsView);
};
export const handleUsageReportViewStrategy:Strategy = () => {
  Mixpanel.track(MixpanelEvents.UsageReportView);
};
export const handleCostExplorerViewStrategy:Strategy = () => {
  Mixpanel.track(MixpanelEvents.CostExplorerView);
};

export const handleBillingInvoicesClientFilterStrategy:Strategy = (payload) => {
  const { clientAccountId } = payload;
  Mixpanel.track(MixpanelEvents.BillingInvoicesClientFilter, {
    clientAccountId
  });
};
export const handleBillingInvoicesStatusFilterStrategy:Strategy = (payload) => {
  const { status } = payload;
  Mixpanel.track(MixpanelEvents.BillingInvoicesStatusFilter, {
    status
  });
};
export const handleBillingInvoicesSearchFilterStrategy:Strategy = (payload) => {
  const { search } = payload;
  Mixpanel.track(MixpanelEvents.BillingInvoicesSearchFilter, {
    search
  });
};
export const handleBillingInvoicesDateFilterStrategy:Strategy = (payload) => {
  const { start, end } = payload;
  Mixpanel.track(MixpanelEvents.BillingInvoicesDateFilter, {
    start,
    end
  });
};
export const handleBillingInvoicesCaseFilterStrategy:Strategy = (payload) => {
  const { caseId } = payload;
  Mixpanel.track(MixpanelEvents.BillingInvoicesCaseFilter, {
    caseId,
  });
};
export const handleBillingInvoicesSelectAllVisibleStrategy:Strategy = () => {
  Mixpanel.track(MixpanelEvents.BillingInvoicesSelectAllVisible);
};
export const handleBillingInvoicesPDFExportStrategy:Strategy = (payload) => {
  const { invoiceId } = payload;
  Mixpanel.track(MixpanelEvents.BillingInvoicesPDFExport, {
    invoiceId
  });
};
export const handleBillingInvoicesACHPaymentStrategy:Strategy = (payload) => {
  const { invoiceId } = payload;
  Mixpanel.track(MixpanelEvents.BillingInvoicesACHPayment, {
    invoiceId
  });
};
export const handleBillingInvoicesCardPaymentStrategy:Strategy = (payload) => {
  const { invoiceId } = payload;
  Mixpanel.track(MixpanelEvents.BillingInvoicesCardPayment, {
    invoiceId
  });
};
export const handleBillingInvoicesBulkPDFExportStrategy:Strategy = (payload) => {
  const { invoicesIds } = payload;
  Mixpanel.track(MixpanelEvents.BillingInvoicesBulkPDFExport, {
    invoicesIds
  });
};
export const handleBillingInvoicesBulkACHPaymentStrategy:Strategy = (payload) => {
  const { invoicesIds } = payload;
  Mixpanel.track(MixpanelEvents.BillingInvoicesBulkACHPayment, {
    invoicesIds
  });
};
export const handleBillingInvoicesBulkCardPaymentStrategy:Strategy = (payload) => {
  const { invoicesIds } = payload;
  Mixpanel.track(MixpanelEvents.BillingInvoicesBulkCardPayment, {
    invoicesIds
  });
};


export const handleCostExplorerBreakdownSwitchStrategy:Strategy = (payload) => {
  const { breakdown } = payload;
  Mixpanel.track(MixpanelEvents.CostExplorerBreakdownSwitch, {
    breakdown
  });
};
export const handleCostExplorerClientFilterStrategy:Strategy = (payload) => {
  const { clientAccountId } = payload;
  Mixpanel.track(MixpanelEvents.CostExplorerClientFilter, {
    clientAccountId
  });
};
export const handleCostExplorerSubscriptionFilterStrategy:Strategy = (payload) => {
  const { subscriptionId } = payload;
  Mixpanel.track(MixpanelEvents.CostExplorerSubscriptionFilter, {
    subscriptionId
  });
};
export const handleCostExplorerServiceFilterStrategy:Strategy = (payload) => {
  const { serviceId } = payload;
  Mixpanel.track(MixpanelEvents.CostExplorerServiceFilter, {
    serviceId
  });
};
export const handleCostExplorerCaseFilterStrategy:Strategy = (payload) => {
  const { caseId } = payload;
  Mixpanel.track(MixpanelEvents.CostExplorerCaseFilter, {
    caseId
  });
};
export const handleCostExplorerDateFilterStrategy:Strategy = (payload) => {
  const { start, end } = payload;
  Mixpanel.track(MixpanelEvents.CostExplorerDateFilter, {
    start,
    end
  });
};
export const handleCostExplorerShowAllInvoicesStrategy:Strategy = () => {
  Mixpanel.track(MixpanelEvents.CostExplorerShowAllInvoices);
};
export const handleCostExplorerInvoiceClickStrategy:Strategy = (payload) => {
  const { invoiceNumber } = payload;
  Mixpanel.track(MixpanelEvents.CostExplorerInvoiceClick, {
    invoiceNumber
  });
};
